<template lang="pug">
.l-article-content(
  :class="{hotoke:store.ui.state.hotoke}"
)
  .l-article-content__inner
    div(v-html="contents")
    //- .
      //- <div class="entry-content">
      //-   <h2>h2見出し</h2>
      //-   <h3>h3見出し</h3>
      //-   <h4>h4見出し</h4>
      //-   <h5>h5見出し</h5>
      //-   <h6>h6見出し</h6>
      //-   <p>倶利伽羅不動寺の本堂へ向かう途中で、本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文。</p>
      //-   <figure class="wp-block-embed is-type-video is-provider-youtube wp-block-embed-youtube wp-embed-aspect-16-9 wp-has-aspect-ratio">
      //-     <div class="wp-block-embed__wrapper"> <iframe loading="lazy" title="【大本山倶利加羅不動寺】密教の奥義であなたの願いを叶えます‼護摩法要【導師森下瑞堂】" width="750" height="422" src="https://www.youtube.com/embed/9Ev2kehaPiw?feature=oembed" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> </div>
      //-   </figure>
      //-   <p>↓↓画像とキャプションセットのやつ。</p>
      //-   <div class="wp-block-columns">
      //-     <div class="wp-block-column">
      //-       <figure class="wp-block-image size-large"><img loading="lazy" width="500" height="500" src="https://kurikarashirube.net/wp-content/uploads/2021/03/500x500.png" alt="" class="wp-image-6" srcset="https://kurikarashirube.net/wp-content/uploads/2021/03/500x500.png 500w, https://kurikarashirube.net/wp-content/uploads/2021/03/500x500-300x300.png 300w, https://kurikarashirube.net/wp-content/uploads/2021/03/500x500-150x150.png 150w" sizes="(max-width: 500px) 100vw, 500px" />
      //-         <figcaption>大きな看板が立っているので迷わない</figcaption>
      //-       </figure>
      //-     </div>
      //-     <div class="wp-block-column">
      //-       <figure class="wp-block-image size-large"><img loading="lazy" width="500" height="500" src="https://kurikarashirube.net/wp-content/uploads/2021/03/500x500.png" alt="" class="wp-image-6" srcset="https://kurikarashirube.net/wp-content/uploads/2021/03/500x500.png 500w, https://kurikarashirube.net/wp-content/uploads/2021/03/500x500-300x300.png 300w, https://kurikarashirube.net/wp-content/uploads/2021/03/500x500-150x150.png 150w" sizes="(max-width: 500px) 100vw, 500px" />
      //-         <figcaption>大きな看板が立っているので迷わない</figcaption>
      //-       </figure>
      //-       <p></p>
      //-     </div>
      //-   </div>
      //-   <p>↓↓「もっと見る」ボタンがあるエリア</p>
      //-   <div class="wp-block-columns">
      //-     <div class="wp-block-column">
      //-       <figure class="wp-block-image size-large"><img loading="lazy" width="500" height="500" src="https://kurikarashirube.net/wp-content/uploads/2021/03/500x500.png" alt="" class="wp-image-6" srcset="https://kurikarashirube.net/wp-content/uploads/2021/03/500x500.png 500w, https://kurikarashirube.net/wp-content/uploads/2021/03/500x500-300x300.png 300w, https://kurikarashirube.net/wp-content/uploads/2021/03/500x500-150x150.png 150w" sizes="(max-width: 500px) 100vw, 500px" /></figure>
      //-     </div>
      //-     <div class="wp-block-column">
      //-       <p>池の中から天に登った黒い龍が刻まれた剣は、倶利伽羅不動寺の本堂にいる不動明王が右手に持っています。</p>
      //-       <p><a href="https://google.com" data-type="URL" data-id="https://google.com">もっと見る</a></p>
      //-     </div>
      //-   </div>
      //- </div>

</template>

<style lang="stylus">
@import '~@/assets/styles/foundation/_variables.styl'

.l-article-content
  +pc()
    font-size 18px
  +sp()
    font-size 28px

  &.hotoke
    a
      &:link,
      &:visited
        color #FFF

  &__inner
    margin 0 auto
    +pc()
      padding 40px 0
      width 480px
    +sp()
      padding 40px 0
      width 600px

  h1,h2,h3,h4,h5,h6,p,.wp-block-buttons
    margin-top 30px
    margin-bottom 30px

  h1
    font-weight bold
    +pc()
      font-size 40px
    +sp()
      font-size 40px
  
  h2
    font-weight bold
    +pc()
      font-size 32px
    +sp()
      font-size 32px

  h3
    font-weight bold
    +pc()
      font-size 22px
    +sp()
      font-size 24px

  h4
    font-weight bold
    +pc()
      font-size 20px
    +sp()
      font-size 21px

  h5
    font-weight bold
    +pc()
      font-size 18px
    +sp()
      font-size 18px

  h6
    font-weight bold
    +pc()
      font-size 16px
    +sp()
      font-size 16px
  
  .wp-block-embed-youtube
    iframe
      border-radius 20px
      +pc()
        height 270px
      +sp()
        height 338px

  .wp-block-image
    img
      width 100%
      height auto
      border-radius 20px
    figcaption
      +pc()
        font-size 16px
      +sp()
        font-size 22px
 
  .wp-block-column
    &:nth-child(2n)
      +pc()
        margin-left 20px
      +sp()
        margin-left 25px
  
  .ex-more-block
    background-color #eae7dd
    border-radius 20px
    +pc()
      padding 25px
    +sp()
      padding 30px
    
    .wp-block-column
      +pc()
        &:nth-child(1)
          flex-grow 1.3
        &:nth-child(2)
          flex-grow 2
      +sp()
        &:nth-child(1)
          flex-grow 1.3
          flex-basis 0 !important
        &:nth-child(2)
          flex-grow 2
          flex-basis 0 !important
      p
        margin-top 0
        margin-bottom 0
        +pc()
          font-size 18px
        +sp()
          font-size 24px
        a
          display table
          background-color #FFF
          border-radius 12px
          text-decoration none
          font-weight bold
          box-shadow 0 0 10px rgba(155,155,155,0.2)
          +pc()
            margin-top 10px
            font-size 16px
            padding 4px 18px
            transition transform 150ms
            &:hover
              transform scale(1.05)
          +sp()
            margin-top 20px
            font-size 21px
            padding 4px 25px

  .wp-block-buttons
    display block
    box-sizing border-box
    .wp-block-button
      margin 0
      padding 0
      display block
      box-sizing border-box
      +pc()
        margin-top 24px
      +sp()
        margin-top 24px
      &:first-child
        margin-top 0

      .wp-block-button__link
        position relative
        background-color #404040
        border-width 3px
        color #FFFFFF
        width 100%
        border-radius 12px
        font-weight bold
        display block
        box-sizing border-box
        padding 0
        border none
        position relative
        +pc()
          font-size 16px
          height 50px
          line-height 48px
          transition transform 150ms
          &:hover
            transform scale(1.04)
        +sp()
          font-size 21px
          height 60px
          line-height 58px

    .wp-block-button.is-style-outline
      .wp-block-button__link
        background-color #FFF
        color #404040
        &:after
          content ""
          wh()
          pos()
          border 3px solid #e6e6e6
          border-radius 12px




  
  ^[0].hotoke .wp-block-buttons .wp-block-button .wp-block-button__link
    background-color #FFF
    color #404040
  
  ^[0].hotoke .wp-block-buttons .wp-block-button.is-style-outline .wp-block-button__link
    background-color #cdb966
    color #404040
    &:after
      border 3px solid #cdb966
  
  ^[0].hotoke .ex-more-block
    background-color #5f5f5f
  ^[0].hotoke .ex-more-block .wp-block-column p a
    color #404040

</style>


<script>
import { defineComponent, computed, ref, onMounted, reactive } from "vue"
import { useStore } from '@/store'
import { useRoute, useRouter } from 'vue-router'
import $ from 'jquery'

export default defineComponent({
  name:'ArticleContent',

  components:{},

  setup(props, context) {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()

    const contents = computed(()=>{
      let contents = store.api.getSpotById(route.params.id).contents
      
      let $contents = $('<div></div>')
      $contents.append(contents)

      //もっと見るボタンエリアにclassを付与する
      $contents.find('.wp-block-columns').each((i,v)=>{
        let check1 = $(v).find('.wp-block-column').length == 2
        let check2 = $(v).find('.wp-block-column').eq(0).find('img').length > 0
        let check3 = $(v).find('.wp-block-column').eq(1).find('img').length == 0
        if(check1 && check2  && check3){
          $(v).addClass('ex-more-block')
        }
      })

      $contents.find('.wp-block-embed.is-provider-youtube .wp-block-embed__wrapper').each((i,v)=>{
        let src = $(v).text()
        let ids = src.match(/\\?v=(.*)/)
        if(ids.length >= 1){
          let id =ids[1]
          let iframe = '<iframe width="100%" height="100%" src="https://www.youtube.com/embed/'+id+'" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
          $(v).html(iframe)
        }
      })

      // var script1 = document.createElement('script')
      // script1.src = "http://kurikarashirube.net/wp-content/themes/twentytwentyone/assets/js/responsive-embeds.js?ver=1.2"
      // var script2 = document.createElement('script')
      // script2.src = "http://kurikarashirube.net/wp-includes/js/wp-embed.min.js?ver=5.7"
      // $contents.append(script1)
      // $contents.append(script2)

      return $contents.html()
    })

    onMounted(async ()=>{
      // console.log('ArticleContent mounted!',route.params.id)
    })

    return{
      contents,
      store
    }
  }
})
</script>
